<template>
  <v-container
    fill-height
    justify-content-start
    :class="{'pa-2': $vuetify.breakpoint.xsOnly}"
    class="app-section-width"
  >
    <v-layout column>
      <v-toolbar color="white" flat>
        <v-btn icon light @click="exit()">
          <v-icon color="grey darken-2">mdi-arrow-left</v-icon>
        </v-btn>
        <v-toolbar-title class="grey--text text--darken-4 pa-0">{{getDashboardName({url: $route.path})}}</v-toolbar-title>
      </v-toolbar>
      <v-layout v-if="loading" justify-center>
        <v-progress-circular indeterminate />
      </v-layout>
      <v-layout v-else column class="app-scroll-section">
        <div>
          <v-select
            hide-details
            :label="$t('fields.payment_account')"
            v-model="selectedAccount"
            :items="accounts"
            item-text="name"
            item-value="value"
            filled
            return-object
            :class="accounts != null && accounts.length === 1 ? 'd-none' : ''"
          ></v-select>
        </div>
        <v-alert
          v-if="!isActiveAccount"
          dense
          text
          icon="error_outline"
          text--justify-center
          color="warning-text"
          type="warning"
          class="warning mt-2"
        >{{ $t('accounts.deactivated_account') }}</v-alert>
        <currencies-and-balance
          :currencies="currencies"
          @filterByCurrencies="(currencies) => filterByCurrencies(currencies)"
        />
        <v-layout
          column
          align-center
          id="transactions"
          v-if="transactions.length > 0 || loadingTransactions"
          @scroll="scroll()"
          style="overflow-y: scroll;-webkit-overflow-scrolling: touch;"
        >
          <v-btn class="ma-1" v-if="!loadingTransactions" icon small @click="refreshTransactions()">
            <v-icon color="grey">refresh</v-icon>
          </v-btn>
          <v-card
            outlined
            class="pa-2 mb-2"
            v-for="transaction in transactions"
            :key="transaction.id"
            style="width: 100%;"
          >
            <v-layout>
              <v-flex xs7>
                <span class="transactional-info">{{ transaction.station}}</span>
                <span class="transactional-info">{{ displayFormatDateAndHour(moment(transaction.created, "DD/MM/YYYY hh:mm")) }}</span>
              </v-flex>
              <v-flex xs5>
                <v-layout justify-end align-center fill-height>
                  <span
                    class="transactional-info-amount grey--text"
                  >{{ transaction.amount }} {{ currencies.find((c) => { return c.id === transaction.currencyId}).name }}</span>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card>
          <div v-if="loadingTransactions">
            <v-progress-circular indeterminate color="secondary" class="my-2"></v-progress-circular>
          </div>
          <span
            v-if="reachedEnd"
            class="user-text body-2 mt-2 mb-2"
          >{{ $t('accounts.no_more_transactions') }}</span>
          <span
            v-if="!loadingTransactions && !reachedEnd"
            class="user-text body-2 mt-2"
            @click="loadMoreTransactions()"
          >{{ $t('accounts.show_more') }}</span>
        </v-layout>
        <v-layout v-else column justify-center align-center class="grey--text">
          <v-btn v-if="!loadingTransactions" icon small @click="selectedAccount ? refreshTransactions() : getBookings()">
            <v-icon color="grey">refresh</v-icon>
          </v-btn>
          {{ $t('accounts.no_transactions') }}
        </v-layout>
        <v-layout wrap class="justify-end" pr-2>
          <v-btn
            v-if="transactions.length > 0"
            fab
            dark
            fixed
            small
            bottom
            color="primary"
            @click="goToTop()"
          >
            <v-icon dark>expand_less</v-icon>
          </v-btn>
        </v-layout>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'
import routeNames from '../router/routes'
import router from '@/router'
import { AccountsRequests } from '@/services/accounts.requests'
import { displayFormatDateAndHour } from '@/lib/helpers/DateUtils'
import { mapGetters } from 'vuex'
const accountService = new AccountsRequests()
export default {
  data () {
    return {
      currencies: [],
      isActiveAccount: true,
      loading: false,
      dialog: false,
      currencyIds: [],
      transactions: [],
      loadingTransactions: false,
      offset: 0,
      limit: 10,
      reachedEnd: false,
      lastOffset: null,
      displayFormatDateAndHour,
      moment,
    }
  },
  methods: {
    exit () {
      router.push({ name: routeNames.main.name })
    },
    getBookings () {
      this.$store.dispatch('me/getBookings')
    },
    getAccount () {
      this.loading = true
      this.$store.commit('accounts/resetAccount')
      this.$store
        .dispatch('accounts/getAccount', { id: this.selectedAccount.id })
        .then((account) => {
          this.currencies = account.currencies
          this.isActiveAccount = account.active
          this.refreshTransactions()
        })
        .finally(() => {
          this.loading = false
        })
    },
    filterByCurrencies (currencies) {
      this.currencyIds = currencies
        ? currencies.map((item) => {
          return item.id
        })
        : []
      this.refreshTransactions()
    },
    getTransactions () {
      if (this.lastOffset !== this.offset) {
        this.loadingTransactions = true
        this.lastOffset = this.offset
        return new Promise(() => {
          accountService
            .getTransactions({
              limit: this.limit,
              offset: this.offset,
              accountIds: [this.selectedAccount.id],
              currencyIds: this.currencyIds,
            })
            .then(async (response) => {
              this.loadingTransactions = false
              if (response.transactions.length === 0) {
                this.reachedEnd = true
              } else {
                this.transactions.push.apply(
                  this.transactions,
                  response.transactions
                )
                if (!response.hasNext) {
                  this.reachedEnd = true
                }
              }
            })
            .finally(() => {
              this.loadingTransactions = false
            })
        })
      }
    },
    refreshTransactions () {
      this.offset = 0
      this.lastOffset = null
      this.reachedEnd = false
      this.transactions = []
      this.getTransactions()
    },
    loadMoreTransactions () {
      this.offset += this.limit
      this.getTransactions()
    },
    goToTop () {
      const scrollDuration = 400
      const transactionList = document.getElementById('transactions')
      var scrollStep = -transactionList.scrollTop / (scrollDuration / 15)
      var scrollInterval = setInterval(function () {
        if (transactionList.scrollTop !== 0) {
          transactionList.scrollBy(0, scrollStep)
        } else clearInterval(scrollInterval)
      }, 15)
    },
    scroll () {
      if (this.loadingTransactions || this.reachedEnd) return
      const o = document.getElementById('transactions')
      if (o) {
        const bottomOfWindow = o.offsetHeight + o.scrollTop === o.scrollHeight
        if (bottomOfWindow && !this.loadingTransactions && !this.reachedEnd) {
          this.loadMoreTransactions()
        }
      }
    },
  },
  components: {
    CurrenciesAndBalance: () =>
      import('@/components/view-components/CurrenciesAndBalance.vue'),
  },
  computed: {
    selectedAccount: {
      get () {
        return this.$store.state.me.currentAccount
      },
      set (value) {
        this.$store.state.me.currentAccount = value
      },
    },
    ...mapGetters({
      accounts: 'me/accounts',
      getDashboardName: 'service/getDashboardName',
    }),
  },
  watch: {
    selectedAccount (value) {
      if (value) {
        this.currencyIds = []
        this.getAccount()
      }
    },
  },
  created () {
    this.getBookings()
  },
}
</script>

<style lang="scss">
#accounts {
  max-width: 430px !important;
  padding: 15px 15px 0 15px;

  .v-toolbar__content {
    padding: 0;
  }
}

.transactional-info {
  display: block;
  font-size: 14px;
}

.transactional-info-amount {
  display: block;
  font-size: 18px;
}

#content {
  overflow-y: auto;
}
</style>
